import { first } from 'lodash'
import { GeneralAPI } from '../../apis/GeneralAPI'
import LegalPage from '../../components/LegalPage'
import { buildLegalMeta, getLegalPageTitle } from '../../helpers/legalPages'

export default function TermsPage(props) {
    return <LegalPage {...props} />
}

export async function getStaticProps() {
    const data = first(await GeneralAPI.getPageBySlug('terms'))
    const title = getLegalPageTitle(data, 'Terms of Service')

    if (!data) {
        return {
            notFound: true,
            revalidate: 10,
        }
    }
    const { meta, metaTitle } = buildLegalMeta({
        data,
        title,
        path: '/terms',
    })

    return {
        props: {
            currentPath: '/terms',
            data,
            meta,
            metaTitle,
            title,
        },
        revalidate: 10,
    }
}
